import { Spin, DatePicker } from "antd";
import axios from "axios";
import React, { useContext, useState, useEffect } from "react";
import moment from "moment";
import {
    baseUrl,
    capitalizeFirst,
    lowerCase,
    momentDate,
    numberToWords,
    printDocument,
    semesterValue,
} from "../../utils";

import {
    MOB_ICONS,
    getFileLiveUrl,
    sleep,

    yearBySem,
} from "../../utils";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { SELECT_USER_PHOTO } from "../../utils/data";
import PsContext from "../../context";
import { Image } from "antd";

import { TABLE_STYLES, VENDOR_LOGO } from "../../utils/data";

import { upperCase } from "../../utils";
import { PAGE_LAYOUT, PAGE_SIZE } from "../../utils/data";
import { ServiceUrl } from "../../utils/serviceUrl";
import { useLocation, useNavigate } from "react-router-dom";


const PrintPdf = (props) => {
    const context = useContext(PsContext);
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const [selectedDate, setSelectedDate] = useState(null);
    const [dataList, setDataList] = useState([]);
    const [selMonth, setSelMonth] = useState(moment());
    const [editorContent, setEditorContent] = useState("");
    const [validated, setValidated] = useState(false);
    const [dataView, setDataView] = useState(props.dataSource);

    // const [dataView, setDataView] = useState([]);



    const field = (fieldName) => {
        console.log('ttt', props.dataSource);
        if (dataView && dataView[0][fieldName])
            return dataView[0][fieldName];
    };



    useEffect(() => {
        printDocument("view_student_print");

        if (props.onSuccess) props.onSuccess();
    }, [props]);



    return (
        <>
            <div>
                <div id="view_student_print" style={{ border: "1px solid black", display: "none" }} >
                    <table>
                        <thead>
                            <tr>
                                <td>
                                    <th colSpan={12} align="center" height="30">
                                        <b>{context.settingValue("billheader_name")}</b>
                                        <br />
                                        {context.settingValue("billheader_addresslineone") && (
                                            <>
                                                {context.settingValue("billheader_addresslineone")} <br />
                                            </>
                                        )}
                                        {context.settingValue("billheader_addresslinetwo") && (
                                            <>
                                                {context.settingValue("billheader_addresslinetwo")} <br />
                                            </>
                                        )}
                                    </th>
                                </td>
                                {/* <td>
                                    <Image
                                        src={getFileLiveUrl(field("profile_photo"))}
                                        fallback={SELECT_USER_PHOTO}
                                        style={{ maxHeight: "100px", width: "100px" }}

                                    />
                                </td> */}
                            </tr>

                        </thead>
                        <tbody>
                            <table
                                width="100%"
                                align="center"
                                style={TABLE_STYLES.tableCollapse}
                                className="font-bookman"

                            >
                                <thead> <h2>APPLICATION FOR OBTAINING DEGREE CERTIFICATE:</h2>
                                    <h4>
                                        COURSE    :  {field("course_name")}   &nbsp;&nbsp;  MAJOR:  &nbsp;&nbsp;{context.user.degree_name} &nbsp;&nbsp; REG NO:   {field("registerno")}
                                    </h4>


                                </thead>


                                <tbody style={{ fontSize: "20px" }}>
                                    <tr>
                                        <tr> 1. NAME OF THE CANDIDATE With initials (IN BLOCK LETTERS):- (To be printed in
                                            the
                                            Certificate)
                                        </tr>
                                        <tr>
                                            {/* <td>In English  :  {field("student_name")}</td> */}
                                            <tr style={{ fontSize: "15px" }}>
                                                <td >In English     : <u style={{ borderBottom: "1px solid black", width: "400px", display: "inline-block", textDecoration: "none", paddingLeft: "50px" }}>{field("student_name")}</u></td>



                                            </tr>

                                            <tr style={{ fontSize: "15px" }}>
                                                <td >தமிழில்    : <u style={{ borderBottom: "1px solid black", width: "400px", display: "inline-block", textDecoration: "none" }}>{field("student_name_tamil")}</u></td>
                                            </tr>

                                        </tr>
                                    </tr>


                                    <tr>
                                        <td> 2. Expansion of the Initial (Father and Mother's Name)
                                        </td>
                                    </tr>
                                    <tr>
                                        {/* <td>In English  :  {field("student_name")}</td> */}
                                        <tr style={{ fontSize: "15px" }}>
                                            <td > a. Father    English     : <u style={{ borderBottom: "1px solid black", width: "300px", display: "inline-block", textDecoration: "none" }}>{field("father_name")}</u></td>



                                        </tr>

                                        <tr style={{ fontSize: "15px" }}>
                                            <td >தமிழில்    : <u style={{ borderBottom: "1px solid black", width: "300px", display: "inline-block", textDecoration: "none" }}>{field("father_name_tamil")}</u></td>
                                        </tr>

                                    </tr>

                                    <tr>
                                        {/* <td>In English  :  {field("student_name")}</td> */}
                                        <tr style={{ fontSize: "15px" }}>
                                            <td > b. Mother  In English     : <u style={{ borderBottom: "1px solid black", width: "300px", display: "inline-block", textDecoration: "none" }}>{field("mother_name")}</u></td>



                                        </tr>

                                        <tr style={{ fontSize: "15px" }}>
                                            <td >தமிழில்    : <u style={{ borderBottom: "1px solid black", width: "300px", display: "inline-block", textDecoration: "none" }}>{field("mother_name_tamil")}</u></td>
                                        </tr>

                                    </tr>
                                    <tr></tr>

                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Sex    : {field("gender")} </td>
                                        {/* <td></td> */}
                                    </tr>
                                    {/* <tr>
                                    <td>3. Sex:</td>
                                    <td><input type="checkbox" name="gender" value="male"> Male</td>
                                    <td><input type="checkbox" name="gender" value="female"> Female</td>
                                    <td><input type="checkbox" name="gender" value="transgender"> Transgender</td>
                                </tr> */}
                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Name of the College  :  {context.settingValue("billheader_name")}</td>

                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Month & Year of Passing    :{field("yearofpassing")} </td>
                                        {/* <td></td> */}
                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Residential Address with Pincode   : {field("address")} {field("pincode")} </td>

                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Mobile No   : {field("mobile_no")}     Email ID : {field("email")}</td>

                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Mobile No   : {field("father_mobile_number")}  &&  {field("mother_mobile_number")} </td>

                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Station : PALAYAMKOTTAI</td>

                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td>Date : </td>
                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td style={{ textAlign: "end" }}>signature of the Candidate</td>
                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td style={{ textAlign: "center", fontWeight: "bold" }}>FORWARDED TO THE UNIVERSITY</td>

                                    </tr>
                                    <tr></tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td style={{ fontWeight: "bold" }}> office seal</td>

                                    </tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td style={{ fontWeight: "bold" }}> Date : </td>
                                    </tr>
                                    <tr style={{ fontSize: "15px" }}>
                                        <td style={{ fontWeight: "bold", textAlign: "end" }}> Signature of the Principal </td>
                                    </tr>

                                </tbody>



                            </table>

                        </tbody>
                    </table>



                </div >
            </div >
        </>
    );
};
export default PrintPdf;
